import React from 'react'
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import ProDialogBody from './ProDialogBody';
import { useDialogService } from '../../hooks/useDialogService';
import _ from 'lodash'

const ProDialog = ({show, header, body, icon, labelOk = "Proceed", labelCancel="Cancel",  severity})=>{

    const {actions:{HandleOk, HandleCancel, HideDialog}} = useDialogService()   
   
    const renderFooter = () => {
        return (
            <div className='p-d-flex p-jc-end'>
                <Button label= {labelCancel}   onClick={()=>{HandleCancel(); HideDialog(); } } className="p-button-text" />
                <Button label={labelOk}  className= {severity} onClick={()=>{HandleOk(); HideDialog()}} autoFocus />
            </div>
        );
    }
    const minHeight = _.isNull(body)? '4vw':'10vw'

  
    return (        
        <Dialog header={header}  escape  visible={show} style={{ minWidth: '25vw', width:'25vw', minHeight:minHeight }} footer={renderFooter} onHide={HideDialog}>
              <ProDialogBody body={body} icon={icon} severity={severity}/>
        </Dialog>
       
    )

}

export default ProDialog;

